class RewardsPointService {
  constructor(client) {
    this.apiClient = client;
  }

  async adjustPoints(payload) {
    return await this.apiClient.post(`onepark/rewardsPoint/Adjust`, payload);
  }
}

export default RewardsPointService;
